module.exports = __webpack_public_path__ + "img/footer-bg.6e74932a.png";